import CoreTableService from './table';

export { CoreTableService };
